import React, { useRef } from 'react';

import { Container } from '@hpstellar/core';

import withPageComponents from '../../../page/components/with-page-components';
import { DynamicYieldTrackingContainer } from '../../../third-party-tags/dynamic-yield-context';

import Topseller from '../../../shared/components/topseller';
import withEinstein from '../../../einstein/withEinstein';
import { useIsPrivateStore } from '../../../hooks/useUserData';
import { useDYChoose } from '../../../hooks/useDynamicYieldRecs';

import './home-popular-products.less';

export const HomeProductsCarousel = ({
    vanityUrl,
    dyName = 'Homepage Recommendations - Bottom',
    defaultTitle,
    defaultContent,
}) => {
    const { [dyName]: dyChoose } = useDYChoose([dyName]);
    const { productRecs: products, dyContainerTracking, fetching, error, title = defaultTitle } = dyChoose || {};

    if ((!fetching && products?.length === 0) || error || !dyChoose) {
        return defaultContent || null;
    }

    return (
        <DynamicYieldTrackingContainer
            className="homePopularProductsDY"
            {...(dyContainerTracking || {})}
            ContainerComponent={Container}
        >
            <HomeTopSeller vanityUrl={vanityUrl} products={products} fetching={fetching} isDY title={title} />
        </DynamicYieldTrackingContainer>
    );
};

const HomePopularProductsEinstein = withEinstein(
    withPageComponents(
        ({ homePopularProducts, vanityUrl, einsteinProducts, einsteinDisabledStore, einsteinFetching }) => {
            const { products: fallbackProducts = [] } = homePopularProducts || {};
            const products = einsteinProducts && einsteinProducts.length > 0 ? einsteinProducts : fallbackProducts;

            if ((einsteinDisabledStore || !einsteinFetching) && products?.length < 1) {
                return null;
            }

            return <HomeTopSeller vanityUrl={vanityUrl} products={products} className="einstein" />;
        },
        { components: ['homePopularProducts'] }
    ),
    'homePopularProducts'
);

const HomeTopSeller = ({ vanityUrl, className, title = 'You may also like', products, fetching, isDY, ...rest }) => {
    const carouselSettings = {
        className: 'home-popular-products-carousel',
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        showDotsCounter: true,
        arrows: true,
        infinite: true,
        equalHeight: true,
        responsive: [
            {
                breakpoint: 1919,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 1365,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    draggable: true,
                    slidesToShow: 1.4,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <Topseller
            products={products}
            title={title}
            carouselSettings={carouselSettings}
            className={'home-popular-products' + `${className ? ` ${className}` : ''}`}
            productTileClassName="home-popular-card"
            list="home-popularproduct"
            vanityUrl={vanityUrl}
            loading={fetching}
            isDY={isDY}
            componentKey="homePopularProducts"
            linkTarget="_self"
            priceProps={{ size: 'large' }}
            {...rest}
        />
    );
};

export default () => {
    const isPrivateStore = useIsPrivateStore();

    if (isPrivateStore) {
        return <HomePopularProductsEinstein />;
    }

    return <HomeProductsCarousel vanityUrl="/" />;
};
